var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.getClassByType(),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon!=null)?_c('a-icon',{staticStyle:{"margin-right":"4px"},attrs:{"type":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }